// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import ViewComfy from "@material-ui/icons/ViewComfy";
import Settings from "@material-ui/icons/Settings";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import LocationOn from "@material-ui/icons/LocationOn";
import ApartmentIcon from '@material-ui/icons/LocationCity';
// core components/views for Admin layout
import Lockers from "views/Lockers/Lockers.js";
import ListLockers from "views/ListLockers"
import Relatorios from "views/Relatorios";
import RelatoriosFabrika from "views/Relatorios/RelatoriosFabrika";
import Configuracoes from "views/Configuracoes";
import Users from "views/Users";
import DashboardView from "views/Dashboard/Dashboard.js"
import Maps from "views/Maps/Maps.js";
import LockersModel from "views/Lockers/LockersModel.js";
import Usuarios from 'views/Usuarios/index.js'
import Condominio from 'views/Condominio/index.js'

const dashboardRoutes = [
  /*todo: DashBoard ainda não está implementado.*/
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "Dashboard",
    icon: Dashboard,
    component: DashboardView,
    layout: "/admin",
  },
  {
    path: "/lockers",
    name: "Lockers",
    rtlName: "Lockers",
    icon: ViewComfy,
    component: Lockers,
    layout: "/admin",
  },

  {
    path: "/maps",
    name: "Maps",
    rtlName: "Maps",
    icon: LocationOn,
    component: Maps,
    layout: "/admin"
  },
  
  {
    path: "/users",
    name: "Usuários",
    rtlName: "Usuários",
    icon: Person,
    component: Usuarios,
    layout: "/admin",
  },
  
  {
    path: "/condominio",
    name: "Condomínio",
    rtlName: "Condomínio",
    icon: ApartmentIcon,
    component: Condominio,
    layout: "/admin",
  },
  
  /* todo Relatórios e configurações ainda não implementado.
  {
    path: "/relatorios",
    name: "Relatórios",
    icon: LibraryBooks,
    component: Relatorios,
    layout: "/admin",
  },
  {
    path: "/config",
    name: "Configurações",
    icon: Settings,
    component: Configuracoes,
    layout: "/admin",
  },*/
  /*{
    path: "/relatorios",
    name: "Relatórios",
    icon: LibraryBooks,
    component: RelatoriosFabrika,
    layout: "/admin",
  },*/
  /*{
    path: "/config",
    name: "Configurações",
    icon: Settings,
    component: Configuracoes,
    layout: "/admin",
  },*/

];

export default dashboardRoutes;
